module.exports = __webpack_public_path__ + "static/vilnius-d98be08e5b5797259963d9fb1202dfb9.png";